import isBoolean from 'lodash/isBoolean.js';
import isNil from 'lodash/isNil.js';
import get from 'lodash/get.js';
import PendoIcon from '../icon/pendo-icon.vue.js';

var script = {
  name: 'PendoCheckbox',
  components: {
    PendoIcon
  },
  inject: {
    $checkboxGroup: {
      default: ''
    },
    $form: {
      default: ''
    },
    $formItem: {
      default: ''
    }
  },
  props: {
    value: {
      type: [String, Boolean, Number],
      default: false
    },
    label: {
      type: String,
      default: null
    },
    id: {
      type: Number,
      default() {
        return this._uid;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: null
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    trueValue: {
      type: [String, Number],
      default: undefined
    },
    falseValue: {
      type: [String, Number],
      default: undefined
    },
    controls: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      focus: false,
      isCheckboxGroupLimitExceeded: false
    };
  },
  computed: {
    model: {
      get() {
        if (this.isCheckboxGroupChild) {
          return this.$checkboxGroup.value;
        }
        if (this.value !== undefined) {
          return this.value;
        }
        return false;
      },
      set(val) {
        if (this.isCheckboxGroupChild) {
          this.isCheckboxGroupLimitExceeded = false;
          const {
            min,
            max
          } = this.$checkboxGroup;
          if (min !== undefined && val.length < min) {
            this.isCheckboxGroupLimitExceeded = true;
          }
          if (max !== undefined && val.length > max) {
            this.isCheckboxGroupLimitExceeded = true;
          }
          if (this.isCheckboxGroupLimitExceeded === false) {
            this.$checkboxGroup.$emit('input', val);
          }
        } else {
          this.$emit('input', val);
        }
      }
    },
    isChecked() {
      if (isBoolean(this.model)) {
        return this.model;
      }
      if (Array.isArray(this.model)) {
        return this.model.includes(this.label);
      }
      if (!isNil(this.model)) {
        return this.model === this.trueValue;
      }
      return false;
    },
    isCheckboxGroupChild() {
      return Boolean(this.$checkboxGroup);
    },
    isDisabled() {
      const isCheckboxGroupDisabled = get(this, '$checkboxGroup.disabled', false);
      const isFormDisabled = get(this, '$form.disabled', false);
      return this.disabled || isCheckboxGroupDisabled || isFormDisabled;
    }
  },
  watch: {
    value(value) {
      if (this.$formItem) {
        this.$formItem.onFieldChange(value);
      }
    }
  },
  created() {
    if (this.checked) {
      this.addToStore();
    }
  },
  mounted() {
    if (this.indeterminate) {
      this.$refs.input.setAttribute('aria-controls', this.controls);
    }
  },
  methods: {
    addToStore() {
      if (Array.isArray(this.model) && this.model.includes(this.label)) {
        this.model.push(this.label);
      } else {
        this.model = this.trueValue || true;
      }
    },
    handleChange(ev) {
      if (this.isCheckboxGroupLimitExceeded) {
        return;
      }
      let value;
      if (ev.target.checked) {
        value = this.trueValue === undefined ? true : this.trueValue;
      } else {
        value = this.falseValue === undefined ? false : this.falseValue;
      }
      this.$emit('change', value, ev);
      this.$nextTick(() => {
        if (this.isCheckboxGroupChild) {
          this.$checkboxGroup.$emit('change', this.$checkboxGroup.value);
        }
      });
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-checkbox.vue2.js.map
